var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-third-form" },
    [
      _c(
        "h2",
        {
          staticClass: "mt-0 mr-4 flex-row mb-0",
          class: { "mb-4": !_vm.getLoading }
        },
        [
          _vm.getLoading
            ? _c("span", { staticClass: "loader mt-2" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "self-center",
              class: { "loading-title ml-2": _vm.getLoading }
            },
            [_vm._v(_vm._s(_vm.searchTitle))]
          )
        ]
      ),
      _vm._v(" "),
      !_vm.getLoading
        ? _c(
            "el-form",
            {
              ref: "searchThirdForm",
              staticClass: "flex-column mb-0",
              attrs: { model: _vm.searchModel }
            },
            [
              _c(
                "div",
                { staticClass: "flex-row" },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "wp-8 mb-0", attrs: { prop: "name" } },
                    [
                      _c("el-input", {
                        ref: "search-input",
                        attrs: {
                          "data-bot": _vm.getDatabot(
                            "name-popup-name",
                            _vm.current
                          ),
                          "prefix-icon": "icon-search"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.process()
                          }
                        },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "wp-3 mx-2 mb-0",
                      attrs: { prop: "country" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "data-bot": _vm.getDatabot(
                              "name-popup-country",
                              _vm.current
                            )
                          },
                          model: {
                            value: _vm.country,
                            callback: function($$v) {
                              _vm.country = $$v
                            },
                            expression: "country"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              value: "FR",
                              label: _vm.$t.__("common.countries.france")
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              value: "GB",
                              label: _vm.$t.__("common.countries.uk")
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("CompassButton", {
                    staticClass: "py-0",
                    attrs: {
                      label: _vm.$t.__("common.actions.search"),
                      type: "primary",
                      disabled: _vm.disabledBtn,
                      "data-bot": _vm.getDatabot("name-popup-btn", _vm.current)
                    },
                    on: {
                      click: function($event) {
                        return _vm.process()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "fs-2 gray-80 mt-1 pb-3 bb-1" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$l10n.__("Nom de la société, SIREN et SIRET")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", [
                !_vm.loading &&
                _vm.nameExistsList.length > 0 &&
                !_vm.disableExistingCompanyList
                  ? _c(
                      "div",
                      { staticClass: "flex-column mt-3 prelative bb-1 pb-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-column search-third-form-exist-container prelative"
                          },
                          [
                            _c("p", { staticClass: "fs-2 gray-80 mt-1" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Société(s) déjà existante(s) dans le répertoire de société"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "m-0 wp-10" },
                              _vm._l(_vm.nameExistsList, function(
                                company,
                                index
                              ) {
                                return _c("form-fields-companies-list", {
                                  key: index,
                                  attrs: {
                                    company: company,
                                    overview: true,
                                    popupForm: true,
                                    allowBadge: "",
                                    overviewWording: _vm.$t.__(
                                      "forms.popups.SearchThirdForm.overview"
                                    )
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.loading && _vm.resultSearch.length > 0
                  ? _c("div", { staticClass: "flex-column pb-2 mt-2" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-column search-third-form-container prelative"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "fs-2 gray-80 mt-1 wp-10",
                              class: { "mt-3": _vm.nameExistsList.length <= 0 }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__("Résultats de votre recherche")
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "m-0 wp-10" },
                            _vm._l(_vm.resultSearch, function(company, index) {
                              return _c("form-fields-companies-list", {
                                key: index,
                                attrs: {
                                  company: company,
                                  enabled: true,
                                  popupForm: true,
                                  displaySiret: ""
                                },
                                on: { "select-company": _vm.selectCompany }
                              })
                            }),
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.loading && _vm.resultSearch.length <= 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "ai-center flex-column search-third-form-not-found"
                      },
                      [
                        _c("img", {
                          staticClass: "h-auto my-4",
                          attrs: {
                            src: "/ressources/public/img/error/no-result.svg"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "semibold gray-60 acenter pb-4 lh-20"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Aucun résultat ne semble correspondre à votre recherche, modifiez vos critères."
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass:
                      "ai-center flex-column prelative search-third-form-not-loading"
                  },
                  [_c("preloader", { attrs: { display: _vm.loading } })],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.disableCreate
                ? _c(
                    "a",
                    {
                      staticClass:
                        "fs-3 pt-4 lh-20 semibold bt-1 hover-primary-100",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$l10n.__("Ajouter une société manuellement"))
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }